import * as Yup from "yup";
import IEFragment from "./IEFragment";

export type ConfigType = {
  component: JSX.Element;
  schema: typeof schema;
  initialValues: SchemaType;
  keysToExclude?: Partial<keyof SchemaType>[];
};

export type SchemaType = Yup.InferType<typeof schema>;

const schema = Yup.object({
  workCountry: Yup.string().oneOf(["IE"]).required("Required"),
  probationPeriodDays: Yup.string()
    .required("Required")
    .oneOf(["0", "90"], "Must be none or 90 days."),
});

const CONFIG: ConfigType = {
  component: <IEFragment />,
  schema: schema,
  initialValues: {
    workCountry: "IE",
    probationPeriodDays: "0",
  },
  keysToExclude: [],
};

export default CONFIG;
